:host {
    display: flex;
    flex-direction: column;
    color: #747474;
    font-family: Frutiger-Light, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    transition: opacity 0.5s ease, transform 0.5s ease;
    opacity: 1;
    transform: translateY(0);
}

:host(.legal-disclaimer--hidden) {
    opacity: 0;
    transform: translateY(-20px);
    pointer-events: none;
}

.legal-disclaimer {
    &--hidden {
        opacity: 0;
        transform: translateY(-20px);
        pointer-events: none;
    }

    &__header {
        margin-bottom: 8px;
    }

    &__content {
        margin-bottom: 30px;
    }

    &__checkbox {
        margin-bottom: 30px;

        input {
            margin-right: 8px;
            accent-color: #bbd03a;
        }
    }

    &__button {
        align-self: center;
    }
}